import React from 'react';
import { Routes, Route, useLocation, useParams } from 'react-router-dom';
import AppFooter from 'components/AppFooter';
import Logo from 'components/Logo';
import {
  LoginPage,
  RegistrationPage,
  ForgotPasswordPage,
  UpdatePasswordPage
} from 'components/pages';
import { Container, MainSection, CornerLogo } from './style';

function AuthContent() {
  const { pathname } = useLocation();
  const { token } = useParams(); // works for dynamic segments like /reset-password/:token

  return (
    <>
      <MainSection isRegisterPage={pathname.includes('/register')}>
        <CornerLogo />
        <Logo size={pathname.includes('/register') ? 'normal' : 'large'} old={1} />
        <Container className="registration-form-page" transparent={pathname.includes('/register')}>
          <Routes>
            <Route
              path="*"
              element={
                pathname.startsWith('/login') ? (
                  <LoginPage />
                ) : pathname.startsWith('/register') ? (
                  <RegistrationPage />
                ) : pathname.startsWith('/forgot-password') ? (
                  <ForgotPasswordPage />
                ) : pathname.startsWith('/reset-password') ? (
                  <UpdatePasswordPage mode="update" token={token} />
                ) : pathname.startsWith('/create-password') ? (
                  <UpdatePasswordPage mode="create" token={token} />
                ) : null
              }
            />
          </Routes>
        </Container>
      </MainSection>
      <AppFooter />
    </>
  );
}

export default AuthContent;
